import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "tipo",
  class: "form-label"
}, "Tipo de Personal: *", -1)
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "nombre",
  class: "form-label"
}, "Nombre Completo: *", -1)
const _hoisted_8 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "tel",
  class: "form-label"
}, "Teléfono: *", -1)
const _hoisted_11 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "form-label"
}, "Correo: ", -1)
const _hoisted_14 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "ced",
  class: "form-label"
}, "Cedulas", -1)
const _hoisted_17 = {
  key: 3,
  class: "col-md-6"
}
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "espe1",
  class: "form-label"
}, "Especialidades:", -1)
const _hoisted_20 = {
  key: 4,
  class: "col-md-6"
}
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "naci",
  class: "form-label"
}, "Fecha de Nacimiento: *", -1)
const _hoisted_23 = {
  key: 5,
  class: "col-md-6"
}
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "ubi",
  class: "form-label"
}, "Ubicación:", -1)
const _hoisted_26 = {
  key: 6,
  class: "col-md-6"
}
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "dir",
  class: "form-label"
}, "Dirección:", -1)
const _hoisted_29 = {
  key: 7,
  class: "col-md-6"
}
const _hoisted_30 = { class: "mb-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: "coment",
  class: "form-label"
}, "Comentarios:", -1)
const _hoisted_32 = { class: "row mt-5" }
const _hoisted_33 = { class: "col-md-12 text-center" }

export function render(_ctx, _cache) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Chips = _resolveComponent("Chips")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("form", {
    autocomplete: "off",
    onSubmit: _cache[10] || (_cache[10] = _withModifiers((...args) => (_ctx.createDoctor && _ctx.createDoctor(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Dropdown, {
            class: "vue-input",
            options: _ctx.tipos,
            modelValue: _ctx.doctor.tipo,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.doctor.tipo) = $event)),
            optionLabel: "valor",
            name: "select1",
            optionValue: "valor",
            placeholder: "Seleccionar...",
            id: "tipo"
          }, null, 8, ["options", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_InputText, {
            id: "nombre",
            autocomplete: "off",
            type: "text",
            class: "vue-input",
            placeholder: "Nombre Completo",
            modelValue: _ctx.doctor.nombre,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.doctor.nombre) = $event)),
            requiered: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      (_ctx.doctor.tipo=='Doctor')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_InputText, {
                id: "tel",
                autocomplete: "off",
                type: "number",
                class: "vue-input",
                placeholder: "Teléfono",
                modelValue: _ctx.doctor.tel,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.doctor.tel) = $event)),
                requiered: ""
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.doctor.tipo=='Doctor')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_InputText, {
                id: "email",
                autocomplete: "off",
                type: "email",
                class: "vue-input",
                placeholder: "Correo",
                modelValue: _ctx.doctor.correo,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.doctor.correo) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.doctor.tipo=='Doctor')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_Chips, {
                separator: ",",
                modelValue: _ctx.doctor.cedula,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.doctor.cedula) = $event)),
                class: "vue-input"
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.doctor.tipo=='Doctor')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_Chips, {
                separator: ",",
                modelValue: _ctx.doctor.especialidad,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.doctor.especialidad) = $event)),
                class: "vue-input"
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.doctor.tipo=='Doctor')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_Calendar, {
                id: "naci",
                class: "vue-input",
                modelValue: _ctx.fecha1,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.fecha1) = $event)),
                dateFormat: "dd/mm/yy",
                showIcon: ""
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.doctor.tipo=='Doctor')
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_InputText, {
                id: "ubi",
                autocomplete: "off",
                type: "text",
                class: "vue-input",
                placeholder: "Ubicación",
                modelValue: _ctx.doctor.ubicacion,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.doctor.ubicacion) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.doctor.tipo=='Doctor')
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_InputText, {
                id: "dir",
                autocomplete: "off",
                type: "text",
                class: "vue-input",
                placeholder: "Dirección",
                modelValue: _ctx.doctor.direccion,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.doctor.direccion) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.doctor.tipo=='Doctor')
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                id: "coment",
                style: {"height":"100px"},
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.doctor.comentario) = $event))
              }, null, 512), [
                [_vModelText, _ctx.doctor.comentario]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_Button, {
          type: "submit",
          label: "Registrar Información",
          severity: "success",
          loading: _ctx.loader,
          icon: "pi pi-save"
        }, null, 8, ["loading"])
      ])
    ])
  ], 32))
}